'use strict';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal, openCreditBoxModal } from '../modules/active_modal';
import { setSoftLoggedIn } from '../modules/is_soft_logged_in';
import { setComputedCart } from '../modules/computed_cart';
import { activeStepCreate, activeStepCheckout } from '../modules/active_enroll_step';
import { clearEbookOrderSuccess} from '../modules/ebook_order_success';
import { getCustomerPaymentMethods } from '../modules/payment_methods';
import { setErrorPath } from '../modules/path';
import { setCategories } from '../modules/categories';
import { setFeatured } from '../modules/featured';
import { setGenres } from '../modules/genres';
import { navigate } from '../modules/high_level_actions';
import { setPromos } from '../modules/promos';
import { setProducts } from '../modules/products';
import { initializeSort } from '../modules/sort';
import { handleSearchNoRedirect } from '../modules/search_query';
import { fireSearchLoading } from '../modules/search_loading';
import { setMaps, buildMaps, initalMoreBooks } from '../modules/maps';
import { constructActiveFilter, setActiveFilter } from '../modules/active_filter';
import { initializeActiveProduct, setActiveProduct } from '../modules/active_product';
import { addEnrollProductToCart }                 from '../modules/cart_actions';
import { createCookie, getCookie, getEnrollCartProductIds } from '../shared/cookie.js';

import BasePage           from './BasePage.jsx';
import ProductDetail      from './ProductDetail.jsx';
import Contact            from './CmsContact.jsx';
import ContactNegOp       from './CmsContactNegOp.jsx';
import MemberServices     from './CmsMemberServices.jsx';
import PrivacyPolicy      from './CmsPrivacyPolicy.jsx';
import TermsOfUse         from './CmsTermsOfUse.jsx';
import TermsOfMembership  from './CmsTermsOfMembership.jsx';
import HowItWorks         from './CmsHowItWorks.jsx';
import AboutUs            from './CmsAboutUs.jsx';
import CatalogView        from './CatalogView.jsx';
import SearchView         from './SearchView.jsx';
import PasswordReset      from './PasswordReset.jsx';
import OneTimePayment     from './OneTimePayment.jsx';
import ErrorPage          from './ErrorPage.jsx';
import NonClubLandingPage from './NonClubLandingPage.jsx';
import NonClubMakePayment from './NonClubMakePayment.jsx';

class App extends Component {
  constructor(props) {
    super(props);
  }

  // everything in componentWillMount can/does render server-side first
  componentWillMount() {
    let {dispatch, maps, genres, path, featured, customer, categories, promos, store_type, campaign, isLoggedIn, activeFilterResult, computedCart}  = this.props;
    if(store_type !== ''){
      // set some default values in case map data doesn't come in properly
      let oEnrollFeatured       = null,
          oMapState             = {
            maps: maps,
            genres: genres,
            featured: featured,
            categories: categories,
            promos: promos
          }

      // Try to reset map/filter/active view values based on map data
      try {
        let oMapState  = buildMaps(maps, null);
        dispatch([
          setCategories( oMapState.categories ),
          setGenres( oMapState.genres ),
          setPromos( oMapState.promos ),
          setFeatured( oMapState.featured ),
          setProducts( oMapState.products ),
          setMaps( oMapState.maps ),
          constructActiveFilter(),
          initializeActiveProduct(),
          initializeSort()
        ]);

        if( typeof window !== 'undefined') dispatch( initalMoreBooks() );
        if ( path === '/search' ) dispatch( fireSearchLoading() );
        if( campaign ) createCookie('campaign', campaign, 4320);

        if( getCookie('campaign') && !isLoggedIn ){
          let campaign = getCookie('campaign'),
              campaignProducts = campaign.split(/[A-Za-z]+/).filter( x => x !== ""),
              campaignType = campaign.split(/[0-9]+/).filter( x => x !== ""),
              enrollFeaturedArray = [],
              selected = 0;

          campaignProducts.forEach( (product, index) => {
            if( campaignType[index] === 'x') enrollFeaturedArray.push(parseInt(product));
            else if( campaignType[index] === 's') selected = parseInt(product);
          });

          if( campaign ) {
            selected = oMapState.get('productMap').get(selected);
            if( selected ) dispatch( addEnrollProductToCart(selected, oMapState));
            if( selected && path === '/')
              dispatch([
                setActiveFilter('product'),
                setActiveProduct(oMapState.get('productMap').get(selected.id))
              ]);
          }
        }
      // If it fails for any reason, change path state to show error page
      } catch (e) {
        console.warn(e);
        dispatch( setErrorPath() );
      }

      // determine what product ids are in enrollment cart
      let aEnrollCart = getEnrollCartProductIds();
      // if maps were successful and enrollCart ids aren't null/undefined,
      // replace cart values with objects from productMap, then compute cart
      if (oMapState.maps) {
       aEnrollCart.forEach((n, i) => {
         if (n)aEnrollCart[i] = {...new Map(new Map(oMapState.maps).get('productMap')).get(n.id), ...n };
       });
       dispatch( setComputedCart(customer, computedCart, aEnrollCart));
      }
      this.props.dispatch([
        clearEbookOrderSuccess(),
        ( customer && (customer.status === "Pending" || customer.status === "Cancelled") ? activeStepCheckout() : activeStepCreate() )
      ]);
    }
  }

  // everything here can/will execute client-side only
  componentDidMount() {
    let { customer, isLoggedIn, dispatch, path, store_type, searchQuery, activeFilterResult } = this.props;
    if( store_type !== ''){
      if(isLoggedIn){
        // determine whether to show credits available message
        var bShowCreditsModal = getCookie('shouldShowCredits') ? true : false;
        if ( customer.current_cycle && customer.current_cycle.active && customer.fulfillment_type === 'Negative' && !bShowCreditsModal && !['CRS','SFC'].includes(this.props.tla) ){
          dispatch( openCreditBoxModal());
          createCookie('shouldShowCredits', true, 60);
        }
        if( customer ) dispatch( getCustomerPaymentMethods() );
      } else{
        // determine whether to show/hide enrollment prompt
        if( getCookie('enrollEmail') ) dispatch( setSoftLoggedIn() );
        dispatch( closeModal() );
      }

      if ( path === '/search' ) dispatch( handleSearchNoRedirect(searchQuery) );
    }

    window.dataLayer.push({ event: 'pageview', url: window.location.hostname + window.location.pathname, logged_in: isLoggedIn });

    // update state when user uses browser Back button
    if (window) {
      window.onpopstate = function (evt) {
      let e = {
        currentTarget: {
          pathname: window.location.pathname
        },
        preventDefault: () => {}
      };
      dispatch(navigate(e));
      }.bind(this);
    }
  }

  render() {
    let oChildComponent = (
      <div className="content-max-width cms">
        <h1>404 - Not Found</h1>
      </div>
    );
    //If you add a new route to pathHash, please whitelist it in componentWillMount (allowedRoutes)
    let pathHash = {
      '/'                   : this.props.store_type !== '' ? <CatalogView  /> : <NonClubLandingPage />,
      '/catalog'            : <CatalogView  />,
      '/search'             : <SearchView />,
      '/contact'            : <Contact />,
      '/contact-us'         : <ContactNegOp />,
      '/member-services'    : <MemberServices />,
      '/privacy-policy'     : <PrivacyPolicy />,
      '/terms-of-use'       : <TermsOfUse />,
      '/terms-of-membership': <TermsOfMembership />,
      '/about-us'           : <AboutUs />,
      '/how-it-works'       : <HowItWorks />,
      '/reset-password'     : <PasswordReset />,
      '/payment'            : this.props.store_type !== '' ? <OneTimePayment /> : <NonClubMakePayment />,
      '/error'              : <ErrorPage />
    };

    if (pathHash[this.props.path]) oChildComponent = pathHash[this.props.path];

    if(this.props.store_type !== '')
      return (
        <BasePage>
          {oChildComponent}
        </BasePage>
      );
    else
      return oChildComponent;
  }
}

function mapStateToProps(state){
    return {
      'activeFilterResult' : state.activeFilterResult,
      'campaign'        : state.campaign,
      'store_type'      : state.store.type,
      'computedCart'    : state.computedCart,
      'featured'        : state.featured,
      'customer'        : state.customer,
      'path'            : state.path,
      'maps'            : state.maps,
      'searchQuery'     : state.searchQuery,
      'isLoggedIn'      : state.isLoggedIn,
      'initials'        : state.store.initials,
      'tla'             : state.store.tla,
    };
}

export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/components/App.jsx